import React from 'react';

const RadioButton = ({ facetValue, facetTypeHeader, handleChange }) => {
	if (facetValue && facetTypeHeader && handleChange) {
		const facetId = `facet_${facetValue.FriendlyName}`;

		return (
			<div className="px-4 py-3 md:py-1 relative">
				<a href={facetValue.Url} tabIndex="-1">
					<label
						htmlFor={`${facetTypeHeader}-${facetId}-${facetValue.Name}`}
						className="facet-type__label c-input-radio inline-flex mr-3 md:-ml-2"
						onClick={(e) => handleChange(e)}>
						<input
							type="radio"
							id={`${facetTypeHeader}-${facetId}-${facetValue.Name}`}
							name={facetTypeHeader}
							value={facetValue.Name}
							onChange={(e) => handleChange(e)}
							checked={facetValue.Selected}
							data-testid="radio-button-input"
						/>
						<span className="c-input__grid flex items-start">
							<span className="c-input__controls facet-value__custom-facet-scale facet-value__radio">
								<span className="c-input-radio-bg"></span>
								<span className="c-input-radio-fg"></span>
							</span>
							<span className="facet-type__label-text c-input__label pl-3 md:pl-0">
								<span className="facet-type__name u-va--middle text-body-sm md:text-xs mr-1">
									{facetValue.Name}
								</span>
								<span className="facet-type__label-total align-middle text-body-sm md:text-xs inline-block">
									({facetValue.Total})
								</span>
							</span>
						</span>
					</label>
				</a>
			</div>
		);
	}

	return null;
};

export default RadioButton;
